module.exports = __webpack_public_path__ + "static/media/users.b4d37256.svg";